import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  className?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon = false,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  href
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variantStyles = {
    primary: 'bg-accent text-white hover:bg-[#b39650] hover:text-white focus:ring-accent',
    secondary: 'bg-primary text-white hover:bg-primary-dark hover:text-white focus:ring-primary',
    outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-white focus:ring-primary'
  };
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm rounded-lg',
    md: 'px-6 py-3 text-base rounded-lg',
    lg: 'px-8 py-4 text-lg rounded-xl'
  };
  const classes = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    return <a href={href} className={classes} data-id="element-25">
        {children}
        {icon && <ArrowRightIcon className="ml-2 h-5 w-5" aria-hidden="true" data-id="element-26" />}
      </a>;
  }
  return <button type={type} onClick={onClick} disabled={disabled} className={classes} data-id="element-27">
      {children}
      {icon && <ArrowRightIcon className="ml-2 h-5 w-5" aria-hidden="true" data-id="element-28" />}
    </button>;
}